import { IonItem } from "@ionic/react";
import React from "react";
import Decimal from "decimal.js";

interface TotalPnlRowProps {
  totalPnl: Decimal;
  aggregatedview: boolean;
  pnlview: boolean;
}

const TotalPnlRow: React.FC<TotalPnlRowProps> = ({
  totalPnl,
  aggregatedview,
  pnlview,
}) => {
  let pnlClass = "";
  if (totalPnl && !totalPnl.isZero()) {
    pnlClass = totalPnl.isPositive() ? "pnl_positive" : "pnl_negative";
  }

  const itemStyle = {
    "--inner-padding-end": "0",
    "--min-height": "30px",
    "--background": "#112B4A",
    border: aggregatedview ? "4px solid var(--ion-color-light)" : "none",
    marginBottom: aggregatedview ? undefined : "2px",
  } as React.CSSProperties;

  const itemContent = (
    <IonItem
      lines="none"
      className="ion-no-padding animate__animated animate__fadeIn"
      style={itemStyle}
    >
      <div
        className="custom_positionsgrid_item"
        style={aggregatedview ? { paddingRight: "35px" } : undefined}
      >
        <div className="pg__contract_netpos_section"></div>
        <div className="pg__buyqty_sellqty_section"></div>
        <div className="pg__avgbuy_avgsell_section"></div>
        <div
          className="pg__refprice_pnl_section"
          style={{ justifyContent: "center" }}
        >
          <div className={`pg__pnl_sub-section ${pnlClass}`}>
            {totalPnl?.toNumber()?.toLocaleString()}
          </div>
        </div>
      </div>
    </IonItem>
  );

  if (!pnlview) {
    return null;
  }

  return aggregatedview ? (
    <div style={{ margin: "10px" }}>{itemContent}</div>
  ) : (
    <>{itemContent}</>
  );
};

export default TotalPnlRow;
